import { Component, OnInit } from '@angular/core';
import { BuNameService } from '../../helper/core/bu-name.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    private buNameService: BuNameService
  ) { }

  ngOnInit() {
    this.buNameService.name = "Module d'inscription Orange";
    this.buNameService.img = "default";
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/page-not-found/page-not-found.component.ts